import { contrastText } from '@/shared/lib/color';
import { ClippedText } from '@/shared/ui';

import type { Label } from '@/entities/board/types';
import styles from './LabelChip.module.css';

interface Props {
  label: Label;
  emptyName: string;
  /**
   * A cut name can be revealed by keyboard focus or a tap (only where the chip is not inside
   * another control, which is itself the focus target).
   */
  reveal?: boolean;
}

/** A label as a colored chip: one line, cut with an ellipsis inside whatever holds it. */
export function LabelChip({ label, emptyName, reveal = false }: Props) {
  const name = label.name || emptyName;
  return (
    <span
      className={styles.chip}
      style={{ background: label.color, color: contrastText(label.color) }}
    >
      <ClippedText passive={!reveal}>{label.name ? label.name : ' '}</ClippedText>
      {!label.name && <span className="visually-hidden">{name}</span>}
    </span>
  );
}
